import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  PRIVACY_POLICY_PARAGRAPHS,
  PRIVACY_POLICY_TITLE,
  PRIVACY_VERSION,
} from '../legal/legalText';

export default function PublicPrivacyPage() {
  const { t } = useTranslation();

  React.useEffect(() => {
    document.title = `Roddo — ${PRIVACY_POLICY_TITLE}`;
  }, []);

  return (
    <div
      className="min-h-[100dvh] bg-[#F7F2E8] px-3 text-[#30271E] dark:bg-[#090D18] dark:text-[#F4F6FA] sm:px-4"
      style={{
        paddingTop: 'max(12px, env(safe-area-inset-top))',
        paddingBottom: 'max(12px, env(safe-area-inset-bottom))',
      }}
    >
      <main
        className="mx-auto flex w-full max-w-3xl items-center justify-center"
        style={{
          height:
            'calc(100dvh - max(12px, env(safe-area-inset-top)) - max(12px, env(safe-area-inset-bottom)))',
        }}
      >
        <section className="flex max-h-full min-h-0 w-full flex-col overflow-hidden rounded-[20px] border border-black/10 bg-[#FFFCF7]/95 shadow-[0_14px_34px_rgba(74,58,42,.10)] backdrop-blur-xl dark:border-white/10 dark:bg-[#121A2B]/95 dark:shadow-[0_16px_38px_rgba(0,0,0,.30)]">
          <header className="relative shrink-0 border-b border-black/10 px-5 py-5 dark:border-white/10 sm:px-6">
            <a
              href="/"
              aria-label={t('legal.backToRoddo', 'Back to Roddo')}
              className="absolute right-4 top-4 inline-flex h-10 w-10 items-center justify-center rounded-full border border-black/10 bg-white/85 text-xl font-black text-[#30271E] shadow-[0_5px_14px_rgba(54,41,80,.08)] transition hover:-translate-y-0.5 hover:brightness-105 active:translate-y-[1px] dark:border-white/10 dark:bg-white/10 dark:text-white"
            >
              ‹
            </a>

            <div className="pr-14">
              <div className="mb-3 inline-flex rounded-full border border-black/10 bg-black/[.035] px-3 py-1.5 text-[10px] font-black uppercase tracking-[0.18em] text-black/50 dark:border-white/10 dark:bg-white/[.07] dark:text-white/60">
                {t('legal.legalDocument', 'Legal')}
              </div>
              <h1 className="text-2xl font-black leading-tight tracking-[-0.025em] sm:text-3xl">
                {PRIVACY_POLICY_TITLE}
              </h1>
              <p className="mt-2 text-xs font-semibold text-black/55 dark:text-white/60">
                {t('common.version', 'Version')} {PRIVACY_VERSION}
              </p>
            </div>
          </header>

          <div
            className="min-h-0 flex-1 space-y-3 overflow-y-auto overscroll-contain px-5 py-5 [-webkit-overflow-scrolling:touch] sm:px-6"
            style={{ touchAction: 'pan-y' }}
          >
            {PRIVACY_POLICY_PARAGRAPHS.map((paragraph, index) => (
              <p
                key={index}
                className="whitespace-pre-line text-[13px] font-medium leading-6 text-[#655C53] dark:text-[#AEB8C9] sm:text-sm"
              >
                {paragraph}
              </p>
            ))}
            <div className="h-3" />
          </div>

          <footer className="shrink-0 border-t border-black/10 bg-[#FBF6EE] px-5 py-4 dark:border-white/10 dark:bg-black/10 sm:px-6">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <div className="text-[11px] font-semibold text-black/45 dark:text-white/50 sm:text-xs">
                {t('legal.publicBookmark', 'You can bookmark this page for later.')}
              </div>
              <div className="flex w-full gap-2 sm:w-auto">
                <button
                  type="button"
                  onClick={() => navigator.clipboard?.writeText(window.location.href)}
                  className="min-h-11 flex-1 rounded-[12px] border border-black/10 bg-white px-4 py-2.5 text-[12px] font-black text-[#30271E] shadow-[0_4px_12px_rgba(54,41,80,.06)] transition hover:-translate-y-0.5 hover:brightness-105 active:translate-y-[1px] dark:border-white/10 dark:bg-white/10 dark:text-white sm:flex-none"
                >
                  {t('common.copyLink', 'Copy link')}
                </button>
                <a
                  href="/"
                  className="inline-flex min-h-11 flex-1 items-center justify-center rounded-[12px] bg-[#2F80ED] px-5 py-2.5 text-[12px] font-black text-white shadow-[0_6px_16px_rgba(47,128,237,.18)] transition hover:-translate-y-0.5 hover:brightness-105 active:translate-y-[1px] dark:bg-[#7057E8] sm:flex-none"
                >
                  {t('legal.backToRoddo', 'Back to Roddo')}
                </a>
              </div>
            </div>
          </footer>
        </section>
      </main>
    </div>
  );
}
